module.exports = __webpack_public_path__ + "static/media/600dcontent.ba94e98a.jpg";